import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdpReportItemModel, AdpReportModel, ContextModel } from '@bayclubs/group-classes-employee-api';
import { TranslateService } from '@ngx-translate/core';
import { ReportFilter, ReportType } from '../../models/reports-model';
import { ReportSelectService } from '../../services/report-select.service';
import { ReportsService } from '../../services/reports.service';
import { BaseReportComponent } from '../base/base-report.component';

@Component({
  selector: 'app-adp-report',
  templateUrl: './adp-report.component.html',
  styleUrls: ['./adp-report.component.scss'],
  standalone: false
})
export class AdpReportComponent extends BaseReportComponent implements OnInit, OnDestroy {

    reportData: AdpReportItemModel[] = [];

    public context: ContextModel;
    constructor(
        activatedRoute: ActivatedRoute,
        reportSelectService: ReportSelectService,
        reportsService: ReportsService,
        translateService: TranslateService
    ) {
        super(activatedRoute, reportSelectService, reportsService, translateService);
    }

    ngOnInit() {
        this.reportType = ReportType.AdpReport;
        super.ngOnInit();
        this.reportData = [];
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    
    filerInstructors(filters){
        console.log(filters);
    }

    showReport(filter: ReportFilter) {
        if (filter === null) {
            this.generateDisabled = true;
            this.reportData = [];
        } else {
            this.subscriptions.add(
                this.reportsService.getAdpReportData(filter).subscribe((value: AdpReportModel) => {
                   
                        this.reportData = value.groupedItems ?? [];
                        if (this.reportData?.length > 0) {
                            this.generateDisabled = false;
                        }
                    
                })
            );
        }
    }

    generateReportFile(filter: ReportFilter) {
        this.subscriptions.add(
            this.reportsService.generateAdpReportFile(filter).subscribe(value => {
                this.downloadReportFile(value, 'adpReport_');
            })
        );
    }
}
